/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


// Popup dialog (image-with-text block)
  const a11y = () => (window.theme && window.theme.a11y) || null;

  const closePopup = (popup) => {
    if (!popup.classList.contains('active')) return;
    popup.classList.remove('active');

    const helper = a11y();
    if (helper) {
      helper.removeTrapFocus({container: popup});
    } else if (popup.__trigger) {
      popup.__trigger.focus();
    }
  };

  const openPopup = (popup, trigger) => {
    popup.classList.add('active');
    popup.__trigger = trigger;

    const helper = a11y();
    if (!helper) return;

    // Record the trigger so removeTrapFocus() can restore focus to it on close.
    helper.state.trigger = trigger;

    // Wait a frame so the dialog is visible before its focusables are collected.
    requestAnimationFrame(() => {
      helper.trapFocus({
        container: popup,
        elementToFocus: popup.querySelector('.modal-close') || popup,
      });
    });
  };

  document.querySelectorAll('.image-with-text__popup a[href^="#popup-"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const popup = document.querySelector(trigger.getAttribute('href'));
      if (popup) openPopup(popup, trigger);
    });
  });

  // Close on the close button, on the backdrop, and on Escape
  document.querySelectorAll('.image-with-text__popup-modal').forEach(popup => {
    popup.addEventListener('click', e => {
      if (e.target === popup || e.target.closest('.modal-close')) {
        closePopup(popup);
      }
    });

    popup.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        closePopup(popup);
      }
    });
  });

  document.querySelectorAll('.image-with-text__popup-backdrop').forEach(backdrop => {
    backdrop.addEventListener('click', () => {
      const popup = backdrop.previousElementSibling;
      if (popup) closePopup(popup);
    });
  });


  // Membership highlight script
  const membershipHighlights = () => {
    const sections = document.querySelectorAll('.section-membership-highlights');

    if (sections.length < 1) return;

    sections.forEach((section) => {
        const images = section.querySelectorAll('.membership-highlights__image img');

        images.forEach((img) => {
            img.style.animationDuration = '2s';
        });

        const blocks = section.querySelectorAll('.membership-highlights__block');
        const imageGroups = section.querySelectorAll('.membership-highlights__images-left, .membership-highlights__images-right');

        if (!blocks.length) return;

        if (section.membershipHighlightsInterval) {
            clearInterval(section.membershipHighlightsInterval);
        }

        let activeIndex = 0;
        let userPaused = false;
        let hovered = false;

        const setActiveBlock = (index) => {
            blocks.forEach((block) => {
                const isActive = block.getAttribute('data-block-index') === String(index);
                block.classList.toggle('is-active', isActive);
            });

            imageGroups.forEach((group) => {
                const isActive = group.getAttribute('data-block-index') === String(index);
                group.classList.toggle('is-active', isActive);
                group.toggleAttribute('hidden', !isActive);
            });
        };

        const stop = () => {
            clearInterval(section.membershipHighlightsInterval);
            section.membershipHighlightsInterval = null;
        };

        const start = () => {
            if (section.membershipHighlightsInterval || userPaused) return;
            section.membershipHighlightsInterval = setInterval(() => {
                activeIndex = (activeIndex + 1) % blocks.length;
                setActiveBlock(activeIndex);
            }, 3000);
        };

        /* WCAG 2.2.2 — a keyboard-operable control to stop the auto-rotation. */
        const strings = (window.theme && window.theme.strings) || {};
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'motion-toggle';

        const syncToggle = () => {
            toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
            toggle.setAttribute(
                'aria-label',
                userPaused
                    ? strings.ticker_play || 'Play automatic rotation'
                    : strings.ticker_pause || 'Pause automatic rotation'
            );
        };

        toggle.innerHTML =
            '<svg class="motion-toggle__pause" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><rect x="1" y="1" width="3.5" height="10" rx="0.5"/><rect x="7.5" y="1" width="3.5" height="10" rx="0.5"/></svg>' +
            '<svg class="motion-toggle__play" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 1.2v9.6a.5.5 0 0 0 .77.42l7.2-4.8a.5.5 0 0 0 0-.84l-7.2-4.8A.5.5 0 0 0 2 1.2Z"/></svg>';

        toggle.addEventListener('click', () => {
            userPaused = !userPaused;
            if (userPaused) {
                stop();
            } else {
                start();
            }
            syncToggle();
        });

        const container = section.querySelector('.membership-highlights');
        if (container && !container.querySelector('.motion-toggle')) {
            syncToggle();
            container.appendChild(toggle);
        }

        // Pause while hovered or keyboard-focused; an explicit pause always wins.
        section.addEventListener('mouseenter', () => { hovered = true; stop(); });
        section.addEventListener('mouseleave', () => { hovered = false; start(); });
        section.addEventListener('focusin', stop);
        section.addEventListener('focusout', () => { if (!hovered) start(); });

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            userPaused = true;
            syncToggle();
            setActiveBlock(0);
            return;
        }

        start();
    });
  };

  document.addEventListener('DOMContentLoaded', membershipHighlights);
  document.addEventListener('shopify:section:load', membershipHighlights);
(function () {
  const CSS_OVERRIDES = `
    .rc-selection__root * {
      color: var(--text) !important;
    }
    .rc-purchase-option[rc-selected] {
      border-color: var(--text) !important;
    }
    #rc-subscription-badge,
    #rc-subscription-badge * {
    color: #FFF !important;
    }
    .strike-through {
    opacity: .5;
    display: none;}
    
    .rc-purchase-option {
    border-width: 3px !important;
    }
  `;

  const VAR_OVERRIDES = {
    '--rc-widget-brand-color': 'var(--text)',
    '--rc-widget-brand-color-10': 'color-mix(in srgb, var(--text) 10%, #ffffff)',
    '--rc-widget-brand-color-20': 'color-mix(in srgb, var(--text) 20%, #ffffff)',
    '--rc-widget-brand-color-50': 'color-mix(in srgb, var(--text) 50%, #ffffff)',
    '--rc-widget-brand-color-70': 'color-mix(in srgb, var(--text) 70%, #ffffff)',
    '--rc-widget-brand-color-80': 'color-mix(in srgb, var(--text) 80%, #ffffff)',
    '--rc-widget-brand-contrast-color': '#FFFFFF',
    '--rc-widget-text-color': 'var(--text)',
    '--rc-widget-selected-bg-color': '#FFFFFF',
    '--rc-widget-selected-text-color': 'var(--text)',
    '--rc-widget-badge-text-color': 'var(--text)',
    '--rc-widget-badge-bg-color': 'var(--text)',
    '--rc-widget-card-radius': '16px',
    '--rc-widget-button-radius': '8px',
    '--rc-widget-badge-radius': '16px',
    '--rc-widget-field-radius': '8px',
  };

  function findShadowHost() {
    const hosts = document.querySelectorAll('*');
    for (const el of hosts) {
      if (el.shadowRoot && el.shadowRoot.querySelector('.rc-selection__root')) {
        return el;
      }
    }
    return null;
  }

  function applyEverything() {
    const host = findShadowHost();
    if (!host) return false;

    const root = host.shadowRoot;
    const target = root.querySelector('.rc-selection__root');

    // 1. inject stylesheet into the shadow root (only once)
    if (!root.querySelector('style[data-custom-override]')) {
      const style = document.createElement('style');
      style.setAttribute('data-custom-override', 'true');
      style.textContent = CSS_OVERRIDES;
      root.appendChild(style);
    }

    // 2. set custom properties directly on the widget element
    for (const [prop, value] of Object.entries(VAR_OVERRIDES)) {
      target.style.setProperty(prop, value, 'important');
    }

    return true;
  }

  // Run once immediately in case it's already there
  applyEverything();

  // Keep watching in case Recharge re-renders and wipes things out
  const observer = new MutationObserver(() => {
    applyEverything();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

// Hide the Recharge widget for one-time-only pack variants (1 Pack / 3 Pack)
(function () {
  const HIDE_PATTERNS = [/\b1\s*pack\b/i, /\b3\s*pack\b/i];
  let hideWidget = false;

  const variantShouldHide = (variant) => {
    if (!variant) return false;
    const names = [variant.title].concat(variant.options || []).filter(Boolean);
    return names.some((name) => HIDE_PATTERNS.some((re) => re.test(name)));
  };

  const findWidgetHost = () => {
    for (const el of document.querySelectorAll('*')) {
      if (el.shadowRoot && el.shadowRoot.querySelector('.rc-selection__root')) return el;
    }
    return null;
  };

  const forceOneTimePurchase = (root) => {
    // Select Recharge's one-time option so its internal state matches the form
    const radios = root.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      const value = (radio.value || '').toLowerCase();
      const label = (radio.closest('label') || radio.closest('.rc-purchase-option') || radio).textContent.toLowerCase();
      const isOnetime = value === 'onetime' || value === 'one_time' || value === '' || /one[\s-]?time/.test(label);
      if (isOnetime) {
        if (!radio.checked) radio.click();
        break;
      }
    }

    // Clear any selling plan the widget already wrote into the product form
    document.querySelectorAll('form[action*="/cart/add"] [name="selling_plan"]').forEach((input) => {
      if (input.value !== '') {
        input.value = '';
        input.dispatchEvent(new Event('change', {bubbles: true}));
      }
    });
  };

  const syncWidgetVisibility = () => {
    const host = findWidgetHost();
    if (!host) return;

    if (hideWidget) {
      forceOneTimePurchase(host.shadowRoot);
      host.style.setProperty('display', 'none', 'important');
    } else {
      host.style.removeProperty('display');
    }
  };

  document.addEventListener('theme:variant:change', (e) => {
    hideWidget = variantShouldHide(e.detail && e.detail.variant);
    syncWidgetVisibility();
  });

  // Set the correct state for the variant selected on page load
  const initialCheck = () => {
    const jsonEl = document.querySelector('[data-product-json]');
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!jsonEl || !idInput) return;

    try {
      const product = JSON.parse(jsonEl.innerHTML);
      const variant = product.variants.find((v) => String(v.id) === String(idInput.value));
      hideWidget = variantShouldHide(variant);
    } catch (error) {
      return;
    }

    syncWidgetVisibility();
  };

  initialCheck();
  document.addEventListener('shopify:section:load', initialCheck);

  // Recharge mounts asynchronously and re-renders — keep visibility in sync
  new MutationObserver(syncWidgetVisibility).observe(document.body, {childList: true, subtree: true});
})();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


